module.exports = __webpack_public_path__ + "img/bottom_cloud_002.fdf5dd48.svg";